// src/components/Nav.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/Nav.css';
import '../index.css'; // Adjust the path as necessary

const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className={`main-nav ${open ? 'open' : ''}`} role="navigation">
      <button
        className="menu-toggle"
        onClick={() => setOpen(!open)}
        aria-label="Toggle navigation"
        aria-expanded={open}
        aria-controls="primary-navigation"
      >
        ☰
      </button>
      <ul id="primary-navigation">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/contact">Contact</Link></li>
        <li><Link to="/pwnedmachines">Pwned Machines</Link></li>
        <li><Link to="/projects">Projects</Link></li>
        <li><Link to="/toolbox">Toolbox</Link></li>
      </ul>
    </nav>
  );
};

export default Nav;